/**
 * Global switch for every link to the external Patientus FAQ (www.patientus.de/faq).
 *
 * The FAQ page is offline while the Patientus website is relaunched (OVS-2551). While this is
 * `false`, the branding store forces `faqLink: false` for all brands, which hides the FAQ links
 * and the "help and tips in our FAQ" sentences. Set it back to `true` once the new FAQ is live
 * to restore each brand's own `faqLink` setting.
 */
export const FAQ_LINK_ENABLED = false;
